const communityReducer = (state = {}, action) => {
    switch(action.type) {
        case 'COMMUNITY_DATA':
            state = action.payload;
            return state;
        default:
            return state;
    }
}

export default communityReducer;